"use client";

import React, { type ReactElement } from "react";
import { ProjectsList, GlobalPageHeader } from "@/components";
import { Project } from "@/types";
import { getApplication } from "@/services/applications";
import { useLocale } from "next-intl";

interface ProjectsMainProps {
  projects: Project[];
}

function ProjectsMain({
  projects,
}: Readonly<ProjectsMainProps>): ReactElement | null {
  const application = getApplication("projects");
  const locale = useLocale();

  if (application) {
    return (
      <>
        <GlobalPageHeader
          title={application!.title[locale]}
          lead={application!.lead[locale]}
        />
        {application.definition ? (
          <section className="max-w-7xl mx-auto grid grid-col-1 md:grid-cols-2 gap-3 p-4">
            <p>{application.definition[locale]}</p>
          </section>
        ) : null}
        <ProjectsList projects={projects} />
      </>
    );
  }

  return null;
}

export { ProjectsMain, type ProjectsMainProps };
